'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = fieldErrorWrapper;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseAlerts = require('@bibliocommons/base-alerts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function fieldErrorWrapper(Component) {
  var FieldError = function (_BcReactComponent) {
    _inherits(FieldError, _BcReactComponent);

    function FieldError(props) {
      _classCallCheck(this, FieldError);

      var _this = _possibleConstructorReturn(this, (FieldError.__proto__ || Object.getPrototypeOf(FieldError)).call(this, props));

      _this.bindAll('renderErrors');
      return _this;
    }

    _createClass(FieldError, [{
      key: 'renderErrors',
      value: function renderErrors() {
        var _props = this.props,
            fieldErrors = _props.fieldErrors,
            errorKey = _props.errorKey,
            intl = _props.intl;

        if (fieldErrors && fieldErrors[errorKey]) {
          return _react2.default.createElement(
            _baseAlerts.AlertFailure,
            null,
            intl.formatMessage({ id: 'error_' + fieldErrors[errorKey].classification.toLowerCase(), defaultMessage: fieldErrors[errorKey].message })
          );
        }
        return null;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props2 = this.props,
            fieldErrors = _props2.fieldErrors,
            errorKey = _props2.errorKey,
            otherProps = _objectWithoutProperties(_props2, ['fieldErrors', 'errorKey']);

        var errorClass = fieldErrors && fieldErrors[errorKey] ? 'has-error' : '';
        return _react2.default.createElement(
          'div',
          { className: errorClass },
          this.renderErrors(),
          _react2.default.createElement(Component, otherProps)
        );
      }
    }]);

    return FieldError;
  }(_baseBcReactComponent2.default);

  FieldError.propTypes = {
    fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
      classification: _react.PropTypes.string,
      message: _react.PropTypes.string
    })),
    errorKey: _react.PropTypes.string.isRequired,
    intl: _reactIntl.intlShape
  };

  return (0, _reactIntl.injectIntl)(FieldError);
}


// WEBPACK FOOTER //
// ../biblio-ui-glue/src/shared/field-error-wrapper/lib/components/FieldErrorWrapper.component.js